
export { RecordModule } from './record.module';
export { RecordResolver } from './record.resolver';
export { RecordListComponent } from './record-list.component';
export { RecordEditComponent } from './record-edit.component';